<ng-container *ngIf="bundles?.length; else noResult">
    <leap-related-bundles-item
            *ngFor="let bundle of bundles"
            [bundle]="bundle"
            [currencySignsMap]="currencySignsMap"
    ></leap-related-bundles-item>
    <nz-pagination
            [nzHideOnSinglePage]="true"
            [nzPageIndex]="pagination.page"
            [nzTotal]="totalCount"
            [nzPageSize]="pagination.limit"
            (nzPageIndexChange)="changePage($event)"
    ></nz-pagination>
</ng-container>

<ng-template #noResult>
    <nz-card>
        No bundles include this product.
    </nz-card>
</ng-template>


